import { Navigate } from "react-router-dom";
import AddCabinet from "../pages/admin/cabinets/AddCabinet";
import Cabinets from "../pages/admin/cabinets/Cabinets";
import EditCabinet from "../pages/admin/cabinets/EditCabinet";
import AddArchive from "../pages/admin/cabinets/files/addArchive/addArchive";
import EditArchive from "../pages/admin/cabinets/files/addArchive/editArchive";
import AddFile from "../pages/admin/cabinets/files/addFile/addFile";
import EditFile from "../pages/admin/cabinets/files/addFile/editFile";
import Archives from "../pages/admin/cabinets/files/Archives";
import Files from "../pages/admin/cabinets/files/Files";
import ArchiveDetail from "../pages/admin/cabinets/files/viewArchive";
import Dashboard from "../pages/admin/dashboard/Dashboard";
import History from "../pages/admin/history/History";
import HistoryDetails from "../pages/admin/history/HistoryDetails";
import HQBranches from "../pages/admin/hqBranches/HQBranches";

import Profile from "../pages/admin/profile/Profile";
import Requests from "../pages/admin/requests/Requests";
import Overview from "../pages/admin/settings/overview";
import AddUsers from "../pages/admin/users/AddUsers";
import EditUser from "../pages/admin/users/EditUser";
import UserDetails from "../pages/admin/users/UserDetails";
import Users from "../pages/admin/users/Users";
import Establishment from "../pages/admin/settings/establishment";
import AdminDirector from "../pages/admin/settings/admin_director";
import AdminsList from "../pages/admin/settings/admins_list";
import AdminDetails from "../pages/admin/settings/admins_detail";
import AddHQBranch from "../pages/admin/hqBranches/AddHQBranch";
import EditHQBranch from "../pages/admin/hqBranches/EditHQBranch";
import EditEstablishment from "../pages/admin/settings/editEstablishment";
import HQBranchDetails from "../pages/admin/hqBranches/HQBranchDetails";
import Departments from "../pages/admin/departments/Departments";
import AddDepartment from "../pages/admin/departments/AddDepartment";
import EditDepartment from "../pages/admin/departments/EditDepartment";
import EditAdminDirector from "../pages/admin/settings/edit_admin_director";
import SubscriptionPlan from "../pages/admin/settings/subscription_plan";
import DepartmentDetails from "../pages/admin/departments/DepartmentDetails";
import TemporaryUsers from "../pages/admin/users/TemporaryUsers";
import TempUserDetails from "../pages/admin/users/TempUserDetails";
import AddTemporaryUser from "../pages/admin/users/AddTemporaryUser";
import EditTemporaryUser from "../pages/admin/users/EditTemporaryUser";
import TemporaryCabinets from "../pages/admin/cabinets/TemporaryCabinets";
import AddTemporaryCabinet from "../pages/admin/cabinets/AddTemporaryCabinet";
import EditTemporaryCabinet from "../pages/admin/cabinets/EditTemporaryCabinet";
import TemporaryFiles from "../pages/admin/cabinets/files/TemporaryFiles";
import AddTemporaryFile from "../pages/admin/cabinets/files/addFile/AddTemporaryFile";
import TemporaryArchives from "../pages/admin/cabinets/files/TemporaryArchives";
import EditTemporaryFile from "../pages/admin/cabinets/files/addFile/EditTemporaryFile";
import AddTemporaryArchive from "../pages/admin/cabinets/files/addArchive/AddTemporaryArchive";
import EditTemporaryArchive from "../pages/admin/cabinets/files/addArchive/EditTemporaryArchive";
import TemporaryArchiveDetail from "../pages/admin/cabinets/files/TemporaryArchiveDetails";
import Referrals from "../pages/admin/referrals/Referrals";
import ViewReferral from "../pages/admin/referrals/ViewReferral";

export const privateRoutes = [
  {
    path: "dashboard",
    element: <Dashboard />,
    // permission: {
    //   collection: 1,
    //   action: 1,
    // },
  },
  {
    path: "cabinets",
    element: <Cabinets />,
    permission: {
      collection: 1,
      action: 1,
    },
  },
  {
    path: "temporary-cabinets",
    element: <TemporaryCabinets />,
    permission: {
      collection: 1,
      action: 1,
      feature: 3
    },
  },
  {
    path: "cabinets/add-cabinet",
    element: <AddCabinet />,
    permission: {
      collection: 1,
      action: 2,
    },
  },
  {
    path: "temporary-cabinets/add-temporary-cabinet",
    element: <AddTemporaryCabinet />,
    permission: {
      collection: 1,
      action: 2,
      feature: 3
    },
  },
  {
    path: "cabinets/edit-cabinet/:id",
    element: <EditCabinet />,
    permission: {
      collection: 1,
      action: 4,
    },
  },
  {
    path: "temporary-cabinets/edit-temporary-cabinet/:id",
    element: <EditTemporaryCabinet />,
    permission: {
      collection: 1,
      action: 4,
      feature: 3
    },
  },
  {
    path: "cabinets/:id/files",
    element: <Files />,
    permission: {
      collection: 2,
      action: 1,
    },
  },
  {
    path: "temporary-cabinets/:id/temporary-files",
    element: <TemporaryFiles />,
    permission: {
      collection: 2,
      action: 1,
      feature: 3
    },
  },
  {
    path: "cabinets/:id/files/add-file",
    element: <AddFile />,
    permission: {
      collection: 2,
      action: 2,
    },
  },
  {
    path: "temporary-cabinets/:id/temporary-files/add-temporary-file",
    element: <AddTemporaryFile />,
    permission: {
      collection: 2,
      action: 2,
      feature: 3
    },
  },
  {
    path: "cabinets/:id/files/edit-file/:fileId",
    element: <EditFile />,
    permission: {
      collection: 2,
      action: 4,
    },
  },
  {
    path: "temporary-cabinets/:id/temporary-files/edit-temporary-file/:fileId",
    element: <EditTemporaryFile />,
    permission: {
      collection: 2,
      action: 4,
      feature: 3
    },
  },
  {
    path: "cabinets/:id/files/:fileId/archives",
    element: <Archives />,
    permission: {
      collection: 3,
      action: 1,
    },
  },
  {
    path: "temporary-cabinets/:id/temporary-files/:fileId/temporary-archives",
    element: <TemporaryArchives />,
    permission: {
      collection: 3,
      action: 1,
      feature: 3
    },
  },
  {
    path: "cabinets/:id/files/:fileId/archives/archive-details/:archiveId",
    element: <ArchiveDetail />,
    permission: {
      collection: 3,
      action: 3,
    },
  },
  {
    path: "temporary-cabinets/:id/temporary-files/:fileId/temporary-archives/temporary-archive-details/:archiveId",
    element: <TemporaryArchiveDetail />,
    permission: {
      collection: 3,
      action: 3,
      feature: 3
    },
  },
  {
    path: "cabinets/:id/files/:fileId/archives/add-archive",
    element: <AddArchive />,
    permission: {
      collection: 3,
      action: 2,
    },
  },
  {
    path: "temporary-cabinets/:id/temporary-files/:fileId/temporary-archives/add-temporary-archive",
    element: <AddTemporaryArchive />,
    permission: {
      collection: 3,
      action: 2,
      feature: 3
    },
  },
  {
    path: "cabinets/:id/files/:fileId/archives/edit-archive/:archiveId",
    element: <EditArchive />,
    permission: {
      collection: 3,
      action: 4,
    },
  },
  {
    path: "temporary-cabinets/:id/temporary-files/:fileId/temporary-archives/edit-temporary-archive/:archiveId",
    element: <EditTemporaryArchive />,
    permission: {
      collection: 3,
      action: 4,
      feature: 3
    },
  },
  {
    path: "requests",
    element: <Requests />,
    permission: {
      collection: 5,
      action: 1,
      feature: 4
    },
  },
  {
    path: "access-log",
    element: <History />,
    permission: {
      collection: 6,
      action: 1,
      feature: 1
    },
  },
  {
    path: "access-log/access-log-details/:id",
    element: <HistoryDetails />,
    permission: {
      collection: 6,
      action: 3,
      feature: 1
    },
  },
  {
    path: "users",
    element: <Users />,
    permission: {
      collection: 4,
      action: 1,
    },
  },
  {
    path: "temporary-users",
    element: <TemporaryUsers />,
    permission: {
      collection: 4,
      action: 1,
      feature: 3
    },
  },
  {
    path: "temporary-users/view-temporary-user/:id",
    element: <TempUserDetails />,
    permission: {
      collection: 4,
      action: 3,
      feature: 3
    },
  },
  {
    path: "users/add-user",
    element: <AddUsers />,
    permission: {
      collection: 4,
      action: 2,
    },
  },
  {
    path: "temporary-users/add-temporary-user",
    element: <AddTemporaryUser />,
    permission: {
      collection: 4,
      action: 2,
      feature: 3
    },
  },
  {
    path: "temporary-users/edit-temporary-user/:id",
    element: <EditTemporaryUser />,
    permission: {
      feature: 3
    },
  },
  {
    path: "users/edit-user/:id",
    element: <EditUser />,
    permission: {
      collection: 4,
      action: 4,
    },
  },
  {
    path: "users/view-user/:id",
    element: <UserDetails />,
    permission: {
      collection: 4,
      action: 3,
    },
  },
  {
    path: "org-structure",
    element: <HQBranches />,
    permission: {
      collection: 7,
      action: 1,
    },
  },
  {
    path: "org-structure/add-hq-branch",
    element: <AddHQBranch />,
    permission: {
      collection: 7,
      action: 2,
    },
  },
  {
    path: "org-structure/edit-hq-branch/:id",
    element: <EditHQBranch />,
    permission: {
      collection: 7,
      action: 4,
    },
  },
  {
    path: "org-structure/view-hq-branch/:id",
    element: <HQBranchDetails />,
    permission: {
      collection: 7,
      action: 3,
    },
  },
  {
    path: "org-structure/departments",
    element: <Departments />,
    permission: {
      collection: 8,
      action: 1,
    },
  },
  {
    path: "org-structure/departments/add-department",
    element: <AddDepartment />,
    permission: {
      collection: 8,
      action: 2,
    },
  },
  {
    path: "org-structure/departments/edit-department",
    element: <EditDepartment />,
    permission: {
      collection: 8,
      action: 4,
    },
  },
  {
    path: "org-structure/departments/view-department",
    element: <DepartmentDetails />,
    permission: {
      collection: 8,
      action: 3,
    },
  },
  {
    path: "profile",
    element: <Profile />,
  },
  {
    path: "settings",
    element: <Navigate to="/settings/overview" />,
  },
  {
    path: "settings/overview",
    element: <Overview />,
  },
  {
    path: "settings/establishment",
    element: <Establishment />,
  },
  {
    path: "settings/establishment/edit",
    element: <EditEstablishment />,
  },
  {
    path: "settings/admin-director",
    element: <AdminDirector />,
  },
  {
    path: "settings/admin-director/edit",
    element: <EditAdminDirector />,
  },

  {
    path: "settings/admins-list",
    element: <AdminsList />,
  },
  {
    path: "settings/admins-list/view-admin/:id",
    element: <AdminDetails />,
  },
  {
    path: "settings/billing",
    element: <SubscriptionPlan />,
  },
  {
    path: "referrals", 
    element: <Referrals />,
  },
  {
    path: "referrals/view/:id", 
    element: <ViewReferral />,
    permission: {
      collection: 1,
      action: 1,
    },
  },
];
